import { SettingsIcon } from '@carboncopyco/icons';
import type { Tour, TourFrame } from '@carboncopyco/types';
import { Button, TextBoxEditorTitle, TooltipBubble } from '@carboncopyco/ui';
import type React from 'react';
import type { UseNavigate } from '../../../../types/dependencies';
import AddingFrames from './AddingFrames';
import useTitleBarActions from './useTitleBarActions';

interface ITitleBar {
  tourId: string;
  frames: TourFrame[];
  selectedFrameIndex: number;
  demoIdsTourIsBasedOn?: number[];
  tour: Tour;
  deeplinkProtocol: string;
  onSettingsButtonClick: () => void;
  useNavigate: UseNavigate;
  openRedirectPage: (url: string) => void;
}

export const TitleBar: React.FC<ITitleBar> = ({
  tourId,
  frames,
  selectedFrameIndex,
  demoIdsTourIsBasedOn,
  deeplinkProtocol,
  tour,
  onSettingsButtonClick,
  useNavigate,
  openRedirectPage,
}) => {
  const { handleAddNewFrames } = useTitleBarActions({
    tourId,
    selectedFrameIndex,
    frames,
  });

  return (
    <div className="flex flex-col flex-1 -mb-4 px-1 pt-1">
      <div className="flex flex-row justify-between">
        <div className="flex items-center">
          <TextBoxEditorTitle
            label="Tour flow"
            uppercase
            color="text-ds-natural-600"
          />
        </div>
        <div className="flex">
          <TooltipBubble
            placement="top"
            title="Settings"
          >
            <Button
              onClick={onSettingsButtonClick}
              icon={<SettingsIcon />}
              dark
            />
          </TooltipBubble>
          <TooltipBubble
            placement="top"
            title="Add frames"
          >
            <AddingFrames
              originalTourId={tourId}
              selectedFrameIndex={selectedFrameIndex}
              demoIdsTourIsBasedOn={demoIdsTourIsBasedOn}
              deeplinkProtocol={deeplinkProtocol}
              tour={tour}
              onDropdownButtonClick={handleAddNewFrames}
              useNavigate={useNavigate}
              openRedirectPage={openRedirectPage}
            />
          </TooltipBubble>
        </div>
      </div>
    </div>
  );
};
